import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Dashboard = () => {
    return (
        <div className="min-h-screen bg-[#0b0f1a] flex flex-col md:flex-row text-white">
            {/* Admin Sidebar */}
            <aside className="w-full md:w-64 bg-[#0f172a] border-r border-white/5 p-6 space-y-8">
                <div>
                    <h2 className="text-[#00F0FF] font-mono text-xs tracking-widest uppercase mb-4 opacity-50">// Admin Console</h2>
                    <h1 className="text-xl font-black font-display tracking-tighter">
                        TOP <span className="text-[#00F0FF]">ORION</span>
                    </h1>
                </div>

                <nav className="space-y-2">
                    <Link to="/admin-portal" className="block px-4 py-3 rounded-lg bg-white/5 border border-[#00F0FF]/20 text-[#00F0FF] font-mono text-sm">
                        > New Blog Post
                    </Link>
                    <Link to="/admin-portal/messages" className="block px-4 py-3 rounded-lg hover:bg-white/5 text-gray-400 font-mono text-sm transition-colors">
                        > Client Messages
                    </Link>
                    <Link to="/" className="block px-4 py-3 rounded-lg hover:bg-red-500/10 text-red-400 font-mono text-sm transition-colors mt-20">
                        [!] Exit Terminal
                    </Link>
                </nav>
            </aside>

            {/* Main Admin Content */}
            <main className="flex-1 p-8 md:p-12 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default Dashboard;